module.exports = __webpack_public_path__ + "static/media/tlog.2ad1861f.png";